<template lang="pug">
    ApolloQuery(:query="require('../graphql/Confirm.gql')", :variables="variables")
        template(slot-scope="{ result: { data }, isLoading }")
            Loading(v-if="isLoading" :active="isLoading")
            page-not-found(v-else-if="!(data && data.form && data.job)")
            .confirmInfo(v-else)
                MetaTags(v-bind="data.job.meta_tags")
                Loading(:active="submitting")
                LayoutBannerBreadCrumb(:locale='locale', :cover="data.form.cover", :title="data.form.title", :name="locale == 'en' ? 'Confirm' : '核對申請表'", :prefix="data.form.title", prefix_url="/jobs", :prefix_two="data.job.title", :prefix_two_url="/jobs/ + data.job.id")
                //- LayoutBannerBreadCrumb(:locale='locale',  :cover="data.form.cover" :name="data.form.title")
                .container.container-confirm
                    .row
                        .col-12
                            h1 {{data.form.confirmation_header}}
                    .row
                        .col-12.text-sm-left
                            h2 {{data.job.title}}
                            p(v-if="data.job.categories.length") {{data.job.categories[0].name}}
                    .row
                        .col-12.confirm
                            .confirm__item
                                .confirm__label
                                    | {{title_label}}:
                                .confirm__value(v-if="locale === 'en'")
                                    | {{form.last_name_title}}&nbsp;
                                .confirm__value
                                    | {{form.last_name}} {{form.first_name}}
                                .confirm__value(v-if="locale !== 'en'")
                                    | &nbsp;{{form.last_name_title}}
                            .confirm__item
                                .confirm__label
                                    | {{data.form.phone}}:
                                .confirm__value
                                    | {{form.phone}}
                            .confirm__item
                                .confirm__label
                                    | {{data.form.email}}:
                                .confirm__value
                                    | {{form.email}}
                    .row
                        .col-12
                            .input
                                .input__label
                                    | {{data.form.uploaded_file}}:
                                .input__files(v-if="uploadedFiles")
                                    .input__file.file(v-for="(file, index) in uploadedFiles", v-bind:key="index")
                                        .file__icon.file__icon-uploaded
                                        .file__name
                                            | {{file.name}} <span class="size" style="float: right">{{file.size}}</span>
                    .row
                        .col-12
                            .input
                                label(for="msg").input__label
                                    | {{data.form.suggestion}}
                                pre.input__content
                                    | {{form.suggestion}}
                                .input__field
                                    input(type="checkbox", name="terms", id="terms", checked, disabled).input__checkbox
                                    .input__checkboxText(v-html="data.form.notice_checkbox")
                .container.container-action
                    .row
                        .col-6
                            .action
                                router-link(to="apply").action__button.action__button-back
                                    | {{data.form.btn_prev}}
                        .col-6.text-sm-right
                            .action
                                vue-recaptcha(:sitekey="sitekey", @verify="onVerify")
                                    button(type="button").action__button.action__button-submit
                                        | {{data.form.btn_confirm}}
                WidgetHowToJoin(v-if='data.form.page_bottom', v-bind='data.form.page_bottom')
</template>

<script>
  import VueRecaptcha from 'vue-recaptcha';

  import LayoutBannerBreadCrumb from "../components/LayoutBannerBreadCrumb.vue";
  import Loading from "../components/Loading.vue";
  import FormDataStore from "../stores/FormDataStore";
  import logTraffic from "../utils/logTraffic";
  import PageNotFound from './PageNotFound';
  import MetaTags from '../components/MetaTags';

  export default {
    name: "Confirm",
    props: {
      locale: String,
      jobID: String,
    },
    components: {
      MetaTags,
      PageNotFound,
      VueRecaptcha,
      LayoutBannerBreadCrumb,
      Loading
    },
    beforeCreate() {
      if (!FormDataStore.validated) {
        this.$router.push('apply');
      }
      FormDataStore.cookie();
    },
    mounted() {
      logTraffic(this.$apollo, this.job_id, 'confirm');

      let recaptcha = document.createElement("script");
      recaptcha.src = "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit";
      recaptcha.async = true;
      recaptcha.defer = true;
      document.head.appendChild(recaptcha);
    },
    data() {
      return {
        form: FormDataStore.data.fields,
        files: FormDataStore.data.files,
        credentials: FormDataStore.data.credentials,
        submitting: false,
        sitekey: '6Lfx3-4bAAAAAMJlCKJ3CWUMFgE19IpZ0jBIPQB2',
      }
    },
    computed: {
      job_id() {
        return parseInt(this.jobID);
      },
      uploadedFiles() {
        return [
          ...this.files.local,
          ...this.files.gdrive,
          ...this.files.dropbox
        ].filter(file => !file.disable);
      },
      variables() {
        const job_id = parseInt(this.jobID);
        return {
          locale: this.locale,
          job_id: job_id ? job_id : -1
        };
      },
      title_label() {
        return this.locale === 'en' ? 'Name' : '姓名';
      },
    },
    methods: {
      async onVerify(response) {
        await this.submit(response);
      },
      async submit(recaptcha_token) {
        this.submitting = true;
        const timeout = setTimeout(this.notifyError, 60000);
        try {
          const result = await this.$apollo.mutate({
            mutation: require('../graphql/ApplyToJob.gql'),
            variables: {
              ...this.form,
              job_id: this.job_id,
              files: this.morphLocalFiles(this.files.local),
              gdrive: {
                access_token: this.credentials.gdrive.access_token,
                api_key: this.credentials.gdrive.api_key,
                files: this.morphFiles(this.files.gdrive)
                  .map(file => ({
                    id: file.id,
                    name: file.name
                  }))
              },
              dropbox: this.morphFiles(this.files.dropbox).map(file => ({
                name: file.name,
                url: file.link
              })),
              recaptcha_token
            }
          });
          clearTimeout(timeout);
          if (this.submitting) {
            if (result && result.data && result.data.apply_to_job)
              this.$router.push({path: 'thankyou'});
            else
              this.notifyError();
          }
        } catch (error) {
          this.notifyError()
        }
      },
      notifyError() {
        this.submitting = false;
        this.$notify({
          group: 'errors',
          title: 'Error',
          text: 'Failed to submit application'
        })
      },
      morphLocalFiles: files => files.filter(file => !file.disable).map(file => file.file),
      morphFiles: files => files.filter(file => !file.disable).map(file => ({...file.file, name: file.name})),
    }
  };
</script>

<style lang="sass">
    @import "../../node_modules/bootstrap/scss/functions"
    @import "../assets/styles/CustomVariables"
    @import "../assets/styles/wysiwyg"
    @import "../assets/styles/common"
    @import "../../node_modules/bootstrap/scss/variables"
    @import "../../node_modules/bootstrap/scss/mixins"
    $color-blue: #7bcee2
    .container-confirm
        padding-top: 3rem
        margin-bottom: 3rem
        @include media-breakpoint-down(md)
            padding-top: 1rem
            margin-bottom: 1rem

        h1
            font-size: 2.5rem
            @include media-breakpoint-down(md)
                font-size: 1.5rem

        h2
            font-size: 2.25rem
            color: $color-blue
            @include media-breakpoint-down(md)
                font-size: 1.25rem

        p
            font-size: 1.5rem
            @include media-breakpoint-down(md)
                font-size: 1.25rem

    .confirm
        margin: 2rem auto
        padding-top: 1rem
        padding-bottom: 1rem
        border-top: #eaeaec 1px solid
        border-bottom: #eaeaec 1px solid
        @include media-breakpoint-down(md)
            margin: 1rem auto

        &__item
            margin: .5rem 0
            font-size: 0

        &__label,
        &__value
            @extend .text-normal
            display: inline-block

        &__label
            width: 8rem
            font-weight: bold

    .container-action
        margin-bottom: 5rem
        @include media-breakpoint-down(md)
            margin-bottom: 2rem

    .input__checkboxText p
        @include media-breakpoint-down(md)
            font-size: 1rem !important
</style>

<style lang="sass" scoped>
    @import "../../node_modules/bootstrap/scss/functions"
    @import "../../node_modules/bootstrap/scss/variables"
    @import "../../node_modules/bootstrap/scss/mixins"
    .file
        &__icon
            min-width: 35px
            background: url('../assets/form/file__icon.png') center center/ auto 80% #ffffff no-repeat
            &-uploaded
                background-image: url('../assets/form/file__icon-uploaded.png')
    .file__name
        width: 93%

    .input__content
        white-space: pre-wrap
        white-space: -moz-pre-wrap
        white-space: -o-pre-wrap
        word-wrap: break-word
</style>
